export function SearchEmpty() {
  return (
    <div className="text-bolt-elements-textTertiary h-full px-3 flex items-center self-center justify-center text-sm">
      No results match your search
    </div>
  );
}
